<section class="flex flex-column gap-3" data-testid="organigrama">
  @if (loading()) {
    <div data-testid="organigrama-loading">
      <app-skeleton-block variant="chart" />
    </div>
  } @else if (error()) {
    <p class="m-0 text-sm text-red-500" data-testid="organigrama-error">{{ error() }}</p>
  } @else {
    <p class="m-0 text-sm text-color-secondary" data-testid="organigrama-fuera">
      Personas sin lider:
      <span class="font-medium text-color">{{ fuera() }} personas.</span>
    </p>
    @if (sinCimas()) {
      <p class="m-0 text-sm text-color-secondary" data-testid="organigrama-sin-cimas">
        No hay una persona con el valor Evadir para iniciar una pirámide.
      </p>
    }
    <div
      class="organigrama-piramides pb-2"
      data-testid="organigrama-piramides"
      appOrganigramaAnimacion
    >
      @for (piramide of piramides(); track piramide.key) {
          <div
            class="organigrama-item"
            [class.organigrama-item--principal]="!piramide.suelta"
            [class.organigrama-item--suelto]="piramide.suelta"
            [attr.data-testid]="piramide.suelta ? 'organigrama-suelto' : 'organigrama-principal'"
          >
            <div class="org-h" appOrganigramaHorizontal>
              <div class="org-h__giro">
                <p-organizationChart
                  [value]="piramide.nodos"
                  [collapsible]="true"
                  [preserveSpace]="false"
                  [styleClass]="piramide.suelta ? 'organigrama-suelto' : ''"
                >
                  <ng-template let-node pTemplate="persona">
                    <span class="org-nodo" appOrganigramaNodo>
                      <div
                        class="organigrama-nodo flex flex-column align-items-center gap-1 text-color border-round"
                        [class.px-2]="!node.data.trinidad"
                        [class.py-1]="!node.data.trinidad"
                        [class.border-1]="!node.data.trinidad && !node.data.sinConexion"
                        [class.surface-border]="!node.data.sinConexion && !node.data.trinidad"
                        [class.organigrama-nodo--suelto]="node.data.sinConexion"
                        [class.organigrama-nodo--trinidad]="node.data.trinidad"
                        [attr.data-org-id]="node.data.id"
                      >
                        @if (!node.data.sinConexion && !node.data.trinidad) {
                          <span class="organigrama-avatar">
                            <p-avatar
                              [label]="node.data.iniciales"
                              shape="circle"
                              [style]="node.data.avatarStyle"
                              [ariaLabel]="node.data.nombreVisible"
                            />
                            @if (node.data.discipulos > 0) {
                              <span
                                class="organigrama-badge"
                                [attr.aria-label]="node.data.discipulos === 1 ? '1 discípulo' : node.data.discipulos + ' discípulos'"
                              >{{ node.data.discipulos }}</span>
                            }
                          </span>
                        }
                        @if (node.data.trinidad) {
                          <span class="organigrama-trinidad"><span>Padre, Hijo</span><span>y Espíritu Santo</span></span>
                        } @else {
                          <span class="text-sm font-medium white-space-nowrap line-height-2">{{ node.data.nombreVisible }}</span>
                          @if (node.data.ministerio) {
                            <span class="text-xs text-color-secondary line-height-2">{{ node.data.ministerio }}</span>
                          }
                          @if (node.data.sinConexion) {
                            <span class="organigrama-sin-conexion text-xs text-red-500 line-height-2">Sin conexión</span>
                          }
                        }
                      </div>
                    </span>
                  </ng-template>
                </p-organizationChart>
              </div>
            </div>
          </div>
        }
    </div>
  }
</section>
